import React from 'react'
import PrivateRoute from '../../utils/PrivateRoute'
import Login from '../login/Login'
import Users from '../../pages/users/Users'
import ClientBusiness from '../../pages/clientBussiness/ClientBusiness'
import Promocode from '../../pages/promocode/Promocode'
import Bin from "../../pages/bin/Bin"
import ClientCampaigns from '../../pages/campaigns/ClientCampaigns'
import AddCampaign from '../../pages/addCampaigndata/addCampaign'
import ViewData from '../../pages/viewCampaigndata/viewData'
import UpdateHeader from "../Update_Campaign/UpdateHeader/UpdateHeader"
import UpdateBody from '../Update_Campaign/UpdateBody/UpdateBody'
import UpdatePlutosHome from "../Update_Campaign/UpdateBody/UpdatePlutosHome"
import UpdateFooter from '../Update_Campaign/UpdateFooter/UpdateFooter'
import { Route, Routes, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import AI_SAAS from '../../pages/ai-saas'
import CONTENT from '../../pages/content'

const AllRoutes = () => {
  const { isAuthenticated } = useSelector((state) => state?.authReducer);
  const token = localStorage.getItem("token")
  
  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated || token ?
            <PrivateRoute Component={Users} /> : <Login />
        }
      />
      <Route
        path="/client-business"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={ClientBusiness} />: <Login />
        }
      />
      <Route
        path="/client-promocode"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={Promocode} />: <Login />
        }
      />
      <Route
        path="/bin"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={Bin} />: <Login />
        }
      />
      <Route
        path="/client-campaign"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={ClientCampaigns} />: <Login />
        }
      />
      <Route
        path="/add-campaignData"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={AddCampaign} />: <Login />
        }
      />
      <Route
        path="/view-campaign"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={ViewData} />: <Login />
        }
      />
      <Route
        path="/ai-saas"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={AI_SAAS} />: <Login />
        }
      />
      <Route
        path="/content"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={CONTENT} />: <Login />
        }
      />
      <Route
        path="/header-page/:searchParams"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={UpdateHeader} />: <Login />
        }
      />
      <Route
        path="/external-body-update/:searchParams"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={UpdateBody} />: <Login />
        }
      />
      <Route
        path="/plutoshome-body-update/:searchParams"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={UpdatePlutosHome} />: <Login />
        }
      />
      <Route
        path="/footer-update/:searchParams"
        element={
          isAuthenticated || token ?
          <PrivateRoute Component={UpdateFooter} />: <Login />
        }
      />
      <Route
        path="*"
        element={
          <Navigate to="/" />
        }
      />
    </Routes>
  )
}

export default AllRoutes
